export default __webpack_public_path__ + "static/media/logo_julian.a9adfe61.svg";